export interface ThemeColors {
  bg: string;
  cardBg: string;
  cardBgHover: string;
  secondaryBg: string;
  tertiaryBg: string;
  border: string;
  borderLight: string;
  text: string;
  textSecondary: string;
  textTertiary: string;
  primary: string;
  success: string;
  warning: string;
  error: string;
  purple: string;
}

export type ThemeMode = 'light' | 'dark';

export interface ThemeState {
  mode: ThemeMode;
  colors: ThemeColors;
}

export const darkTheme: ThemeColors = {
  bg: '#000000',
  cardBg: '#1c1c1e',
  cardBgHover: '#2c2c2e',
  secondaryBg: '#2c2c2e',
  tertiaryBg: '#3c3c3e',
  border: '#2c2c2e',
  borderLight: '#3c3c3e',
  text: '#f5f5f7',
  textSecondary: '#86868b',
  textTertiary: '#6e6e73',
  primary: '#0071e3',
  success: '#30d158',
  warning: '#ff9f0a',
  error: '#ff453a',
  purple: '#bf5af2'
};

export const lightTheme: ThemeColors = {
  bg: '#f5f5f7',
  cardBg: '#ffffff',
  cardBgHover: '#f0f0f2',
  secondaryBg: '#e5e5e7',
  tertiaryBg: '#d5d5d7',
  border: '#d5d5d7',
  borderLight: '#e5e5e7',
  text: '#1d1d1f',
  textSecondary: '#6e6e73',
  textTertiary: '#86868b',
  primary: '#0071e3',
  success: '#30d158',
  warning: '#ff9f0a',
  error: '#ff453a',
  purple: '#bf5af2'
};

export function getThemeColors(isDark: boolean): ThemeColors {
  return isDark ? darkTheme : lightTheme;
}
